import { render, staticRenderFns } from "./STATISTICS.vue?vue&type=template&id=17b4c29d&"
import script from "./STATISTICS.vue?vue&type=script&lang=js&"
export * from "./STATISTICS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports